// src/utils/pip.js
import { Capacitor } from '@capacitor/core';

export const isNative =
  () => (Capacitor.isNativePlatform?.() ?? (Capacitor.getPlatform() !== 'web'));

export async function enterPiPFor(video) {
  if (!video) return;
  if (!canUsePiP()) return;
  // must be playing (or at least loaded) for reliable PiP
  try {
    if (video.readyState < 2) {
      await video.play().catch(() => {});
    }
    if (document.pictureInPictureElement === video) return; // already in PiP
    await video.requestPictureInPicture();
  } catch (err) {
    // swallow or log (optionally toast)
    console.debug('PiP failed:', err?.message || err);
  }
}
export async function exitPiPIf(video) {
  try {
    if (document.pictureInPictureElement && (!video || document.pictureInPictureElement === video)) {
      await document.exitPictureInPicture();
    }
  } catch {}
}

/** Attach native->web PiP event bridge once. Returns a cleanup fn. */
export function registerPiPBridge({ onToggleMic, onHangup, onExpand } = {}) {
  const actionHandler = (e) => {
    const a = e.detail?.action;
    if (a === 'toggle-mic') onToggleMic?.();
    else if (a === 'hangup') onHangup?.();
    else if (a === 'expand') onExpand?.();
  };
  const changedHandler = (e) => {
    const inPip = !!e.detail?.inPip;
    // optional: pause heavy UI when inPip === true
  };

  window.addEventListener('pip-action', actionHandler);
  window.addEventListener('pip-changed', changedHandler);

  // return cleanup
  return () => {
    window.removeEventListener('pip-action', actionHandler);
    window.removeEventListener('pip-changed', changedHandler);
  };
}

export const canUsePiP = () =>
  !!document.pictureInPictureEnabled &&
  typeof HTMLVideoElement !== 'undefined' &&
  'requestPictureInPicture' in HTMLVideoElement.prototype;

export const isMobile = () =>typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);